import React, {Component} from 'react';
import {Container} from './styles';
import {FaChevronDown} from 'react-icons/fa';
import Modal from 'react-modal';

import Options from './options';
import OptionsMobile from '../HeaderMob/options';

import logo from '../../assets/logo_completo_vermelho.svg';
import perfil from '../../assets/perfil/perfil@3x.png';

const customStyles = {
    overlay: {
        zIndex: 8,
        backgroundColor: 'transparent',
      },
      content: {
        WebkitBoxShadow: '0px 2px 8px 0px rgba(0,0,0,0.1)',
        MozBoxShadow: '0px 2px 8px 0px rgba(0,0,0,0.1)',
        boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.1)',
        border: 'none',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '200px',
        left: '64%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '240px',
        height: '100%',
        maxHeight: '174px'
      }
  };

  const mobile = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -42%)',
        width: '100%',
        maxWidth: '360px',
        height: '85%',
      }
  };
export default class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            windowWidth: window.innerWidth,
            nome: '',
            logotipo: ''
        }
    }

    async getRest() {
        const rest = await JSON.parse(localStorage.getItem('@rest'));
        if (rest) {
            this.setState({
                nome: rest.nome,
                logotipo: rest.logotipo
            })
        }
    }

    componentDidMount() {
        Modal.setAppElement('body');
        this.getRest();
        window.addEventListener("resize", this.handleResize);
    }
    
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize, false)
    }

      handleResize = (e) => {
        this.setState({ windowWidth: window.innerWidth });
    }

    render() {
        return (
            <Container modalOpen={this.props.modalOpen}>

                <Modal
                isOpen={this.props.modalOpen}
                // onAfterOpen={this.controllerModal(this.state.isOpen)}
                onRequestClose={() => this.props.closeModal(this.props.modalOpen)}
                shouldCloseOnEsc={true}
                shouldCloseOnOverlayClick={true}
                closeTimeoutMS={100}
                style={this.state.windowWidth <= 690 ? mobile : customStyles}
                contentLabel="Modal"
                >
                        {
                            this.state.windowWidth <= 690 ? 
                            <OptionsMobile 
                            status={this.props.status}
                            change={() => this.props.changeStatus()}
                            closeModal={() => this.props.closeModal(this.props.modalOpen)}/>
                            :
                            <Options 
                            closeModal={() => this.props.closeModal(this.props.modalOpen)}/>
                        }
                </Modal>
                
                <div className="miolo">
                    <div className="logo">
                        <img 
                        alt="Logo"
                        src={logo}
                        className="logocompletovermelho" />
                    </div>

                    <hr/>

                    <div className="restaurante">
                        
                        <div className="rest-container">
                            <div className="logo-rest">
                                <img 
                                alt="Restaurante"
                                src={this.state.logotipo === '' ? perfil : `https://appedidos-share-private.s3.amazonaws.com/${this.state.logotipo}`}
                                className="perfil"
                                />
                            </div>

                            <div className="texto">
                                <h1 className="ola">
                                    Olá,
                                </h1>

                                <div className="rest">
                                    <h1 className="nome">
                                        {this.state.nome}
                                    </h1>

                                    <button 
                                        onClick={() => this.props.closeModal(this.props.modalOpen)}>
                                    <FaChevronDown color={'#a49a9b'} size={14} className="chevron"/>
                                    </button>
                                </div>
                            </div>   
                        </div>

                        <div className="status-container">
                            {/* <button 
                                onClick={() => this.props.changeStatus()}
                                className={this.props.status ? "status-aberto" : "status-fechado"}>
                                <h1 className="statusText">
                                    Restaurante {this.props.status ? 'aberto' : 'fechado'}
                                </h1>
                            </button>  */}
                        </div>
                    
                    </div>
                </div>
            </Container>
        )
    }
}